<template>
    <section>
    <pageHeader>TIME BILLING & ACCOUNTING</pageHeader>
    <UnderLinedHeader class="pt-15 pb-8 white">
        Giving You Peace of Mind
      </UnderLinedHeader>
    <v-row  align="center" class="pt-0 pb-16 pr-16 pl-16">
      <p class="artice-text text-center">
        Time tracking and productivity analysis go hand in hand with financial reporting. Our specialists do it all and help you streamline your workflow. Getting the bills out and preparing the financial results is the goal. We help you produce bills that your clients will pay, and we help you analyze the results of your company’s financial success. Call us to teach you or ask us to do it for you!
      </p>
      </v-row>
      
    <v-row style="justify-content: space-around">
      <v-col
        align="center"
        cols="12"
        s="12"
        xs="12"
        lg="4"
        xl="4"
        md="6"
        v-for="(item, index) in softwares_details"
        :key="index"
      >
        <!--<div class="flip-card">
          <div class="flip-card-inner">
            <div class="flip-card-front" v-html="item.icon"></div>
            <div class="flip-card-back">
              <div class="card_text_style" v-html="item.content"></div>
              <v-btn color="#ebebeb">
                <a
                  v-bind:href="item.url"
                  target="_blank"
                  style="text-decoration: none"
                  ><span style="color: #666">Learn More</span></a
                >
              </v-btn>
            </div>
          </div>
        </div>-->
        <FlipCard >
        <template v-slot:front>
         
             <imageCard :imageName="item.imageName" :alt="item.imageName" parentFolder="Softwares"> </imageCard>
           
        </template>
        <template v-slot:back >
            <div  class="card_text_style"  v-html="item.content"></div>
             <v-btn color="#ebebeb">
                <a
                  v-bind:href="item.url"
                  target="_blank"
                  style="text-decoration: none"
                  ><span style="color: #666">Learn More</span></a
                >
              </v-btn>
        </template>
      </FlipCard>
      </v-col>
    </v-row>
    <CaseStudy
      :text="item.text"
      :link="item.link"
      :color="item.color"
      :caseStudyText="item.caseStudyText"
      :say="item.say"
      :dashedSay="item.dashedSay"
      v-for="(item, index) in articles"
      :key="index"
      :class="item.class"
    >
      <template v-slot:header>
        <underLinedHeader class="pt-0 pb-6" :class="item.color">
          {{ item.title }}</underLinedHeader
        >
      </template>
      <template v-slot:image>
        <v-img
          contain
          :height="imgSize"
          :src="require('@/assets/imgs/Softwares/' + item.imgName)"
          :lazy-src="require('@/assets/imgs/Softwares/' + item.imgName)"
        >
        </v-img>
      </template>
    </CaseStudy>
    
  </section>
</template>

<script>
import PageHeader from "@/components/global/compnentsMixins/PageHeader.vue";
import UnderLinedHeader from "@/components/global/compnentsMixins/UnderLinedHeader.vue";
import FlipCard from "@/components/global/compnentsMixins/FlipCard.vue";
import ImageCard from "@/components/global/ImageCard.vue";
import CaseStudy from "@/components/global/compnentsMixins/CaseStudy.vue";
export default {
  components: { PageHeader, UnderLinedHeader, FlipCard, ImageCard , CaseStudy},
  data(){
    return{
      softwares_details: [
        {
          imageName: 'aderant-360px.png',
          content:
            "Aderant has a variety of solutions for the AMLaw 100 (mid-sized) law firm. It has all of the elements of a total solution and is built on a Microsoft SQL platform.  Our 35/45 data analysts can assist you with SQL Server Reporting Services (SSRS) for Aderant.",
          url: "http://www.aderant.com/",
        },
        {
          imageName: 'cosmolex-360px.png',
          content:
            "Cosmolex is a true cloud product that gives a growing law practice anytime, anywhere access to Legal Time & Billing, Trust (IOLTA) accounting, Document Mangagement, Calendar & Task and Business Accounting.  This all-in-one product is the small firm’s answer to reducing overhead and capitalizing on a cloud based all-in-one.",
          url: "https://www.cosmolex.com/",
        },
        {
          imageName: 'lexisnexis-360px.png',
          content:
            "Manage Your Law Practice Anywhere with the security of LexisNexis® cloud behind you.  This is a small office option for the all-in-one Time & Billing with an introduction to Practice Management.  LexisNexis developed the product with the small law firm in mind.  You can manage your matters, documents and billing from one place.",
          url: "http://firmmanager.com/",
        },
        {
          imageName: 'juris-360px.png',
          content:
            "A market leader for time, billing and accounting for the mid-sized law firm Juris® adds exceptional metrics reporting with the complete Juris Suite.  35/45  enhances the Juris experience by bridging the gap between Juris and other products, in particular, Time Matters to provide a complete solution for the mid-law firm.",
          url: "http://www.lexisnexis.com/business-of-law/products/practice-management/juris",
        },
        {
          imageName: 'PCLaw-NEW-360px.png',
          content:
            "PCLaw® is a preferred product of 35/45 Consulting® for the small to mid-sized law firm.  With a flavor of practice management including calendaring and document management, PCLaw can be a complete solution for the small firm, or an easy to use integrated solution for the mid-size firm.",
          url: "https://pclawtimematters.com/",
        },
        {
          imageName: 'quickbooks-360px.png',
          content:
            "35/45 can help you link QuickBooksTM with other applications, or help you implement QuickBooks as your complete billing and accounting solution. QuickBooks also offers cloud-based and Mac solutions to meet your needs regardless of your environment. Whether it is accounting assistance or setup and implementation, 35/45  can make QuickBooks work for you.",
          url: "https://quickbooks.intuit.com/",
        },
        {
          imageName: 'rk-360px.png',
          content:
            "For over 30 years, law firms of all sizes have relied on Rippe & Kingston for the financial tools to run their practice. Legal Management System (LMS+) provides Management with the needed oversight, reporting tools, support infrastructure and early warning systems to keep law firms profitable and on track.",
          url: "http://www.legal.rippe.com/",
        },
        {
          imageName: 'sage50-360px.png',
          content:
            "With customizable navigators, graphical interface, versions for different industries and flexible reporting options, Sage® offers any business at a glance views of the accounting information needed to manage the financials. Sage 50 includes time reporting, inventory and job costing along with the ability to automate accounting processes.",
          url: "http://www.sage.com/us/sage-50-accounting",
        },
        {
          imageName: 'tabs3-360px.png',
          content:
            "Tabs3® Billing Software minimizes the manual and clerical effort in the billing process and helps partners understand how the law firm is performing. Tabs3® also has customizable compensation rules to make it easy to see how much each attorney has earned each month. Built-in customizable reporting gives the end-user flexibility in the presentation of results.",
          url: "https://www.tabs3.com/",
        },
        {
          imageName: 'timesheet-360px.png',
          content:
            "Sage TimeSheet® is automated time tracking with project management in mind.  TimeSheet is a perfect fit for engineers, architects, consultants, legal professionals and other service professionals who need to track their time efficiently in a familiar spreadsheet environment. 35/45 supports installation sites of virtually any size; from 15 to 3,800 time recorders.",
          url: "https://www.sage.com/na/~/media/site/sage-500-erp/assets/datasheets/Sage_500_ERP_TimeSheet_spec.pdf",
        },
        {
          imageName: 'timeslips-360px.png',
          content:
            "Sage TimeSlips® continues to be a preferred solution for any service company tracking time, expenses for billing, and reporting purposes. 35/45 can help you capture time, bill it and report on your time.  We can also provide your firm with outsourced billing or accounting assistance to analyze the results.",
          url: "http://www.sage.com/us/sage-timeslips",
        },
        {
          imageName: 'timesolv-360px.png',
          content:
            "TimeSolv is an integrative cloud-based project management and billing solution for businesses including Law Firms, Accountants, Consultants, PR Firms, and Freelancers.",
          url: "https://www.timesolv.com/",
        },
        {
          imageName: 'zola-360px.png',
          content:
            "Zola Suite® is an end-to-end practice management platform that delivers a single source of truth. Zola Suite gives you the power of one solution to manage every action taken in every case. One complete, easy-to-use platform. One set of login credentials. One monthly bill.",
          url: "https://zolasuite.com/",
        },
        {
          imageName: 'centerbase-360px.png',
          content:
            "Centerbase is the all-in one legal platform that doesn’t disrupt your workflow—so you can focus on high-value work while automating low-value tasks.",
          url: "https://centerbase.com/",
        },
      ],
      articles: [
        {
          title: "Silverman Thompson Slutkin & White, LLC",
          text: "More and more law firms are discovering that their office server-based technologies can no longer adequately support a range of operational functions from case management to timekeeping & billing to accounting and document management. At the same time, doing the needed complete technology overhaul may seem like a daunting task and many firms may not know where to begin or which criteria are most important in deciding on the next technology to choose and implement. The law firm of Silverman Thompson Slutkin & White found themselves in just that position. Read how the firm quickly learned that the quality of their technology implementation provider was just as important as the quality of the technology platform they were implementing and how these two teams seamlessly worked together to execute a uniquely integrated cloud solution via an innovative tech partnership that was also uniquely customized for Silverman Thompson’s practice areas.",
          imgName: "Silverman-Case-Study-600px.png",
          link: "https://f.hubspotusercontent00.net/hubfs/5825854/Client%20Success%20Stories/Case%20Brief%20Study%20SIlverman%20Thompson%20Final%20-%20ST%20Aug.%2021.pdf",
          caseStudyText: `Read the Silverman Thompson Slutkin & White, LLC Case Study and learn more about how our team can solve for the unknown in nearly any situation.`,
          say: `“3545 Consulting provided a major value-added service to the entire process. In terms of converting our data, providing training to our staff, and working with Zola Suite to customize a solution for us, 3545 Consulting hit the mark on all of these.” `,
          dashedSay: `— Andrew Slutkin, Senior Partner, Silverman Thompson Slutkin & White`,
          class: "greyBG",
          color: "#f8f9f9",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
p.artice-text {
  font-family: $primaryFontFamily;
  font-size: 1em;
}
.flip-card {
  background-color: transparent;
  width: 355px;
  height: 255px;
  perspective: 1000px;
}

.flip-card-inner {
  position: relative;
  width: 100%;
  height: 100%;
  text-align: center;
  transition: transform 0.6s;
  transform-style: preserve-3d;
  /*box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);*/
}

.flip-card:hover .flip-card-inner {
  transform: rotateY(180deg);
}

.flip-card-front,
.flip-card-back {
  position: absolute;
  width: 100%;
  height: 100%;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}

.flip-card-front {
  background-color: rgb(255, 255, 255);
  color: black;
}

.flip-card-back {
  background-color: #ffffff;
  color: rgb(0, 0, 0);
  transform: rotateY(180deg);
}
.card_text_style {
  margin: auto;
  padding-bottom:20px;
}
</style>